import { Flex, FlexProps } from "@chakra-ui/react";

export const CBLabel = (props: FlexProps) => <Flex fontSize="xs" color="gray.500" align="center" {...props} />;
